import { render, staticRenderFns } from "./AdminColorPicker.vue?vue&type=template&id=688cef7f&"
import script from "./AdminColorPicker.vue?vue&type=script&lang=ts&"
export * from "./AdminColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./AdminColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VMenu,VSpacer,VTextField})
